const sanityClient = require('@sanity/client');
const imageUrlBuilder = require('@sanity/image-url');
const client = sanityClient({
  projectId: '2vtv415l',
  dataset: 'production',
  // token: configOptions.accessToken,
  useCdn: false, // `false` if you want to ensure fresh data
});
module.exports = imageUrlBuilder(client);
